import { CWCSupplierCardProps } from '../CWCSupplierCard/CWCSupplierCard'
import cidacosDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/cidacos-desktop.webp'
import cidacosFallbackPng from '../../../../assets/OurSuppliersSectionAssets/cidacos-fallback.png'
import cidacosMobileWebp from '../../../../assets/OurSuppliersSectionAssets/cidacos-mobile.webp'
import dunbiaDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/dunbia-desktop.webp'
import dunbiaFallbackPng from '../../../../assets/OurSuppliersSectionAssets/dunbia-fallback.png'
import dunbiaMobileWebp from '../../../../assets/OurSuppliersSectionAssets/dunbia-mobile.webp'
import jollyHogDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/jolly-hog-desktop.webp'
import jollyHogFallbackPng from '../../../../assets/OurSuppliersSectionAssets/jolly-hog-fallback.png'
import jollyHogMobileWebp from '../../../../assets/OurSuppliersSectionAssets/jolly-hog-mobile.webp'
import tofooDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/tofoo-desktop.webp'
import tofooFallbackPng from '../../../../assets/OurSuppliersSectionAssets/tofoo-fallback.png'
import tofooMobileWebp from '../../../../assets/OurSuppliersSectionAssets/tofoo-mobile.webp'
import yeoValleyDesktopWebp from '../../../../assets/OurSuppliersSectionAssets/yeo-valley-desktop.webp'
import yeoValleyFallbackPng from '../../../../assets/OurSuppliersSectionAssets/yeo-valley-fallback.png'
import yeoValleyMobileWebp from '../../../../assets/OurSuppliersSectionAssets/yeo-valley-mobile.webp'

// Forked from OurSuppliersSection's `supplierCardProps` so the shared config (live on Control,
// RAF and paid-search) stays byte-for-byte untouched. Same five suppliers and imagery; the only
// data delta is the Jolly Hog tag, updated per the CwC design ("B Corp | Great Taste Award").
// Yeo Valley "Organic Farming" pending Alicia's sign-off (desktop frame's "Soil Association
// Organic" looks like a copy-paste slip); Cidacos & Dunbia intentionally carry no tag.
export const cwcSupplierCardProps: CWCSupplierCardProps[] = [
  {
    webpSmall: yeoValleyMobileWebp,
    webpLarge: yeoValleyDesktopWebp,
    fallback: yeoValleyFallbackPng,
    alt: 'Smiling Yeo Valley owners standing in a green field with rolling countryside in the background',
    supplierDetails: {
      title: 'Yeo Valley Organic',
      location: 'Somerset, UK',
      since: 'Supplier since 2018',
      tag: 'Organic Farming',
    },
  },
  {
    webpSmall: tofooMobileWebp,
    webpLarge: tofooDesktopWebp,
    fallback: tofooFallbackPng,
    alt: 'Spiced tofu and green bean stir-fry served over rice on a blue plate, with fork alongside',
    supplierDetails: {
      title: 'ToFoo',
      location: 'Yorkshire, UK',
      since: 'Supplier since 2018',
      tag: 'Soil Association Organic',
    },
  },
  {
    webpSmall: jollyHogMobileWebp,
    webpLarge: jollyHogDesktopWebp,
    fallback: jollyHogFallbackPng,
    alt: 'Three smiling The Jolly Hog owners holding packs of their sausages',
    supplierDetails: {
      title: 'Jolly Hog',
      location: 'Bristol, UK',
      since: 'Supplier since 2021',
      tag: 'B Corp | Great Taste Award',
    },
  },
  {
    webpSmall: cidacosMobileWebp,
    webpLarge: cidacosDesktopWebp,
    fallback: cidacosFallbackPng,
    alt: 'Close-up of a mix of colourful heirloom tomatoes by Cidacos',
    supplierDetails: {
      title: 'Cidacos',
      location: 'Toledo, Spain',
      since: 'Supplier since 2019',
    },
  },
  {
    webpSmall: dunbiaMobileWebp,
    webpLarge: dunbiaDesktopWebp,
    fallback: dunbiaFallbackPng,
    alt: 'Overhead shot of a raw steak with rosemary, a meat cleaver and peppercorns on a wooden board',
    supplierDetails: {
      title: 'Dunbia',
      location: 'Cross Hands, UK',
      since: 'Supplier since 2024',
    },
  },
]
